<template>
  <div>
    <b-card>
      <div class="d-flex mb-2">
        <div class="w-75 mr-auto">
          <b-input-group size="sm">
            <b-form-input
              v-model="termo_pesquisa"
              v-on:keyup.enter="loadData"
              placeholder="Pesquisar"
            ></b-form-input>
            <b-input-group-append>
              <b-button @click="loadData" variant="exitos">Buscar</b-button>
            </b-input-group-append>
          </b-input-group>
        </div>
        <div v-if="actions != 'select'">
          <b-button
            size="sm"
            variant="exitos"
            :to="{ name: 'contrapartidas_create' }"
            v-if="$can('contrapartidas:create')"
            @click="$emit('novo')"
          >
            <font-awesome-icon icon="plus" />
            Novo
          </b-button>
        </div>
      </div>

      <b-table
        striped
        hover
        :items="contrapartidas"
        :fields="fields"
        :busy="isBusy"
        @sort-changed="sortingChanged"
        show-empty
        sort-icon-left
      >
        <template #cell(descricao)="{ item }">
          <div class="limit-text limit-text-3-lines">
            {{ item.descricao }}
          </div>
        </template>
        <template #cell(actions)="row">
          <Actions
            :item="row.item"
            :view_show="false"
            :view_edit="$can('contrapartidas:edit')"
            :view_delete="$can('contrapartidas:delete')"
            edit_to="contrapartidas_edit"
            @delete="deleteItem"
          />
        </template>
        <template #cell(select)="{ item }">
          <b-form-checkbox
            v-model="selecionados"
            name="selecionados"
            :value="item"
          />
        </template>

        <template #empty="{}">
          <h5 class="text-center">Nenhum item encontado</h5>
        </template>

        <template #table-busy>
          <div class="text-center my-2">
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </template>
      </b-table>
    </b-card>

    <div>
      <pagination-nav :pagination="pagination" @input="loadData()" />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import mixins from "@/components/Table/mixins";

export default {
  mixins: [mixins],

  props: {
    actions: {
      type: String,
      default: "default",
    },
  },
  data: () => ({
    selecionados: [],
  }),
  computed: {
    ...mapState("contrapartidas", ["contrapartidas", "pagination"]),
    ...mapGetters("oportunidades", ["tipos_contrapartida"]),
    fields() {
      let fields = [
        {
          key: "tipo_contrapartida",
          label: "Tipo",
          class: "col-2",
          formatter: (value, head, object) => {
            let response = _.find(this.tipos_contrapartida, { value: value });
            return response ? response.text : "";
          },
        },
        { key: "descricao", label: "Descrição" },
        {
          key: "minima",
          label: "Min",
          class: "col-2 text-right",
          formatter: (value, head, object) => {
            let response =
              object.tipo_contrapartida == "negociavel" || !object.unidade
                ? "--"
                : this.$options.filters.number_format(value);

            if (object.unidade) {
              response += " (" + object.unidade + ")";
            }

            return response;
          },
        },
        {
          key: "maxima",
          label: "Max",
          class: "col-2 text-right",
          formatter: (value, head, object) => {
            let response =
              object.tipo_contrapartida == "negociavel" || !object.unidade
                ? "--"
                : this.$options.filters.number_format(value);

            if (object.unidade) {
              response += " (" + object.unidade + ")";
            }

            return response;
          },
        },
      ];

      if (this.actions == "default") {
        fields.push({ key: "actions", label: "", class: "cell-actions" });
      }

      if (this.actions == "select") {
        fields.push({ key: "select", label: "", class: "col-1" });
      }

      return fields;
    },
  },
  methods: {
    ...mapActions("contrapartidas", ["ActionGetAll", "ActionDelete"]),
  },
  async created() {
    if (this.$route.query.page > 1) {
      this.page = this.$route.query.page;
    }
    if (this.$route.query.q != "") {
      this.termo_pesquisa = this.$route.query.q;
    }
    this.loadData();
  },
};
</script>

<style lang="scss">
table {
  td {
    white-space: normal !important;
  }
}
.table-truncate {
  max-width: 0;

  .table-truncate-content {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
